<template>
  <button
    :class="{ collapsed: !collapsed }"
    @click="toggleNavigationState"
    type="button"
    class="btn btn-reset shadow-none hd-TopMenu_MobileMenuToggle hd-TopMenu_Link"
  >
    <Close v-if="collapsed" class="svg-24 text-dark" />
    <Burger v-else class="svg-24 hd-TopMenu_MobileMenuIcon" />
  </button>
</template>

<script>
import Close from "../../icons/atalanda/x.svg";
import Burger from "../../icons/atalanda/burger.svg";

import { mapActions } from "vuex";

export default {
  name: "MobilMenuToggle",
  components: {
    Close,
    Burger,
  },
  props: {
    collapsed: {
      type: Boolean,
    },
  },
  methods: {
    ...mapActions({ toggleNavigationState: "toggleNavigationState" }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.collapsed {
  .hd-TopMenu_MobileMenuToggle {
    .icon-bar {
      background-color: $navbar-foreground-color;
    }
  }

  .hd-TopMenu_HamburgerTopBar {
    transform: rotate(0);
  }

  .hd-TopMenu_HamburgerMiddleBar {
    opacity: 1;
  }

  .hd-TopMenu_HamburgerBottomBar {
    transform: rotate(0);
  }
}
</style>
